import React, { useState } from "react";
import "./Reports_Generation.css";
import Report_Analysis_Sidebar from "./report_analysis_sidebar/Report_Analysis_Sidebar";
import Reports_Routes from "./reports_routes/Reports_Routes";

const Reports_Generation = () => {
  return (
    <section className="Reports_Generation">
      <div className="row me-0 ms-0 p-0">
        <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-4 ps-0">
          <Report_Analysis_Sidebar />
        </div>
        <div className="col-xxl-10 col-xl-9 col-lg-9 col-md-8 col-sm-8 p-0">
          <div className="Management_contnet_holder">

          <Reports_Routes />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reports_Generation;
